import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ContentTooltip } from 'src/app/models/content-tooltip';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-offline',
    templateUrl: './offline.component.' + environment.brand + '.html',
    styleUrls: ['./offline.component.' + environment.brand + '.css']
})
export class OfflineComponent {
    contentTooltips: ContentTooltip[] = [];

    constructor(private router: Router) {
        //console.log('OfflineComponent.constructor');        
    }

    onHome(): void {
        this.router.navigate(['/'])
            .then(() => {
                window.location.reload();
            });
    }
}
